export const disabledButtonByPermission = (permissions, condition) => {
  if (!(permissions[condition])) {
    return 'd-none'
  }
  return ''
}